/* eslint-disable */
/* tslint:disable */
/*
 * ---------------------------------------------------------------
 * ## THIS FILE WAS GENERATED VIA SWAGGER-TYPESCRIPT-API        ##
 * ##                                                           ##
 * ## AUTHOR: acacode                                           ##
 * ## SOURCE: https://github.com/acacode/swagger-typescript-api ##
 * ---------------------------------------------------------------
 */

import {
  MrfiktivBufferGen,
  MrfiktivCreateOutboundInvoiceDocumentDtoGen,
  MrfiktivInvoiceBillingControllerGetParamsGen,
  MrfiktivInvoiceControllerCreatePayloadGen,
  MrfiktivInvoiceControllerGetParamsGen,
  MrfiktivInvoiceControllerUpdatePayloadGen,
  MrfiktivInvoiceViewModelGen,
  MrfiktivMultipleIdsDtoGen,
  MrfiktivPageViewModelGen,
  MrfiktivUpdateInvoiceBillingDtoGen
} from "./data-contracts";
import { ContentType, HttpClient, RequestParams } from "./http-client";

export class Invoice<SecurityDataType = unknown> {
  http: HttpClient<SecurityDataType>;

  constructor(http: HttpClient<SecurityDataType>) {
    this.http = http;
  }

  /**
   * No description
   *
   * @tags invoice
   * @name InvoiceControllerEnsureIndexesAsAdmin
   * @summary (ADMIN) Recreate indexes on invoice collection
   * @request PATCH:/partner/{partnerId}/invoice/ensureIndexesAsAdmin
   * @secure
   * @response `200` `void`
   */
  invoiceControllerEnsureIndexesAsAdmin = (partnerId: string, params: RequestParams = {}) =>
    this.http.request<void, any>({
      path: `/partner/${partnerId}/invoice/ensureIndexesAsAdmin`,
      method: "PATCH",
      secure: true,
      ...params
    });
  /**
   * No description
   *
   * @tags invoice
   * @name InvoiceControllerCreate
   * @summary (Invoice - CREATE) Create an Invoice
   * @request POST:/partner/{partnerId}/invoice
   * @secure
   * @response `201` `MrfiktivInvoiceViewModelGen` The created invoice
   */
  invoiceControllerCreate = (
    partnerId: string,
    data: MrfiktivInvoiceControllerCreatePayloadGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivInvoiceViewModelGen, any>({
      path: `/partner/${partnerId}/invoice`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags invoice
   * @name InvoiceControllerGet
   * @summary (Invoice - READ) Get all invoices
   * @request GET:/partner/{partnerId}/invoice
   * @secure
   * @response `200` `(MrfiktivPageViewModelGen & { data?: (MrfiktivInvoiceViewModelGen)[] })`
   */
  invoiceControllerGet = ({ partnerId, ...query }: MrfiktivInvoiceControllerGetParamsGen, params: RequestParams = {}) =>
    this.http.request<MrfiktivPageViewModelGen & { data?: MrfiktivInvoiceViewModelGen[] }, any>({
      path: `/partner/${partnerId}/invoice`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags invoice
   * @name InvoiceControllerCreatePdf
   * @summary (INVOICE-CREATE) Create a pdf for an invoice
   * @request POST:/partner/{partnerId}/invoice/{invoiceId}/pdf
   * @secure
   * @response `200` `MrfiktivInvoiceViewModelGen` The printed PDF invoice
   */
  invoiceControllerCreatePdf = (partnerId: string, invoiceId: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivInvoiceViewModelGen, any>({
      path: `/partner/${partnerId}/invoice/${invoiceId}/pdf`,
      method: "POST",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags invoice
   * @name InvoiceControllerAddDocument
   * @summary (INVOICE-OUTBOUND-CREATE) Create a custom pdf for an invoice
   * @request POST:/partner/{partnerId}/invoice/{invoiceId}/document
   * @secure
   * @response `200` `MrfiktivInvoiceViewModelGen` The invoice with added document
   */
  invoiceControllerAddDocument = (
    partnerId: string,
    invoiceId: string,
    data: MrfiktivCreateOutboundInvoiceDocumentDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivInvoiceViewModelGen, any>({
      path: `/partner/${partnerId}/invoice/${invoiceId}/document`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags invoice
   * @name InvoiceControllerNext
   * @summary (Invoice - READ) Get the next invoice number
   * @request GET:/partner/{partnerId}/invoice/next
   * @secure
   * @response `200` `number` The next invoice number
   */
  invoiceControllerNext = (partnerId: string, params: RequestParams = {}) =>
    this.http.request<number, any>({
      path: `/partner/${partnerId}/invoice/next`,
      method: "GET",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags invoice
   * @name InvoiceControllerGetOne
   * @summary (Invoice - READ) Get an invoice
   * @request GET:/partner/{partnerId}/invoice/{invoiceId}
   * @secure
   * @response `200` `MrfiktivInvoiceViewModelGen` The invoice
   */
  invoiceControllerGetOne = (partnerId: string, invoiceId: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivInvoiceViewModelGen, any>({
      path: `/partner/${partnerId}/invoice/${invoiceId}`,
      method: "GET",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags invoice
   * @name InvoiceControllerUpdate
   * @summary (Invoice - UPDATE) Updates an invoice
   * @request PATCH:/partner/{partnerId}/invoice/{invoiceId}
   * @secure
   * @response `201` `MrfiktivInvoiceViewModelGen` The updated invoice
   */
  invoiceControllerUpdate = (
    partnerId: string,
    invoiceId: string,
    data: MrfiktivInvoiceControllerUpdatePayloadGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivInvoiceViewModelGen, any>({
      path: `/partner/${partnerId}/invoice/${invoiceId}`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags invoice
   * @name InvoiceControllerDelete
   * @summary (Invoice - DELETE) Deletes an invoice
   * @request DELETE:/partner/{partnerId}/invoice/{invoiceId}
   * @secure
   * @response `200` `MrfiktivInvoiceViewModelGen` The deleted invoice
   */
  invoiceControllerDelete = (partnerId: string, invoiceId: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivInvoiceViewModelGen, any>({
      path: `/partner/${partnerId}/invoice/${invoiceId}`,
      method: "DELETE",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags invoice
   * @name InvoiceControllerGetPdf
   * @summary (INVOICE-READ) Generate a PDF preview for an invoice
   * @request GET:/partner/{partnerId}/invoice/{invoiceId}/preview/pdf
   * @secure
   * @response `200` `MrfiktivBufferGen` PDF for a invoice
   */
  invoiceControllerGetPdf = (partnerId: string, invoiceId: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivBufferGen, any>({
      path: `/partner/${partnerId}/invoice/${invoiceId}/preview/pdf`,
      method: "GET",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags invoice
   * @name InvoiceBillingControllerCreate
   * @summary (BILLING - CREATE) Create a BILLING
   * @request POST:/partner/{partnerId}/billing/invoice
   * @secure
   * @response `201` `(MrfiktivInvoiceViewModelGen)[]` The created invoice
   */
  invoiceBillingControllerCreate = (partnerId: string, data: MrfiktivMultipleIdsDtoGen, params: RequestParams = {}) =>
    this.http.request<MrfiktivInvoiceViewModelGen[], any>({
      path: `/partner/${partnerId}/billing/invoice`,
      method: "POST",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags invoice
   * @name InvoiceBillingControllerGet
   * @summary (BILLING - READ) Get all billable invoices
   * @request GET:/partner/{partnerId}/billing/invoice
   * @secure
   * @response `200` `(MrfiktivPageViewModelGen & { data?: (MrfiktivInvoiceViewModelGen)[] })`
   */
  invoiceBillingControllerGet = (
    { partnerId, ...query }: MrfiktivInvoiceBillingControllerGetParamsGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivPageViewModelGen & { data?: MrfiktivInvoiceViewModelGen[] }, any>({
      path: `/partner/${partnerId}/billing/invoice`,
      method: "GET",
      query: query,
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags invoice
   * @name InvoiceBillingControllerGetOne
   * @summary (BILLING - READ) Get a billing
   * @request GET:/partner/{partnerId}/invoice/{invoiceId}/billing
   * @secure
   * @response `200` `MrfiktivInvoiceViewModelGen` The invoice
   */
  invoiceBillingControllerGetOne = (partnerId: string, invoiceId: string, params: RequestParams = {}) =>
    this.http.request<MrfiktivInvoiceViewModelGen, any>({
      path: `/partner/${partnerId}/invoice/${invoiceId}/billing`,
      method: "GET",
      secure: true,
      format: "json",
      ...params
    });
  /**
   * No description
   *
   * @tags invoice
   * @name InvoiceBillingControllerUpdate
   * @summary (BILLING - UPDATE) Update a billing
   * @request PATCH:/partner/{partnerId}/invoice/{invoiceId}/billing
   * @secure
   * @response `200` `MrfiktivInvoiceViewModelGen` The invoice
   */
  invoiceBillingControllerUpdate = (
    partnerId: string,
    invoiceId: string,
    data: MrfiktivUpdateInvoiceBillingDtoGen,
    params: RequestParams = {}
  ) =>
    this.http.request<MrfiktivInvoiceViewModelGen, any>({
      path: `/partner/${partnerId}/invoice/${invoiceId}/billing`,
      method: "PATCH",
      body: data,
      secure: true,
      type: ContentType.Json,
      format: "json",
      ...params
    });
}
